import {Icon, TextField} from '@shopify/polaris';
import {SearchIcon} from '@shopify/polaris-icons';
import classNames from 'classnames';

import styles from './FilterSearch.scss';

interface FilterSearchProps {
  queryValue?: string;
  queryPlaceholder?: string;
  focused?: boolean;
  onQueryChange(queryValue: string): void;
  onQueryClear(): void;
  onQueryBlur?(): void;
  onQueryFocus?(): void;
  disabled?: boolean;
  alwaysVisibleClearButton?: boolean;
}

export function FilterSearch({
  queryPlaceholder,
  onQueryChange,
  onQueryBlur,
  onQueryFocus,
  queryValue,
  focused,
  onQueryClear,
  disabled,
  alwaysVisibleClearButton,
}: FilterSearchProps) {
  return (
    <div
      className={classNames(
        styles.SearchWrapper,
        alwaysVisibleClearButton && styles.AlwaysVisibleClearButton,
      )}
    >
      <TextField
        placeholder={queryPlaceholder}
        onChange={onQueryChange}
        onBlur={onQueryBlur}
        onFocus={onQueryFocus}
        value={queryValue}
        focused={focused}
        label={queryPlaceholder}
        labelHidden
        prefix={<Icon source={SearchIcon} />}
        clearButton
        onClearButtonClick={onQueryClear}
        autoComplete="off"
        disabled={disabled}
      />
    </div>
  );
}
